/**
 * Created by Julio Perez on 6/23/2017.
 */
export let selectedLink = {
    name: "DEFAULT"
};

export function getSelectedLink(){
    return selectedLink.name;
}

export function setSelectedLink(newName){
    selectedLink = {
        name: newName
    };
}


// WEBPACK FOOTER //
// ./src/app/shared/js/selected-link.js